import { Bolt, Group, SmartToy } from "@mui/icons-material";
import { Box, Grid, SxProps, Theme, Typography } from "@mui/material";
import { SectionContainer } from "src/modules/SectionContainer/SectionContainer";
import { SectionTitle } from "src/modules/SectionTitle/SectionTitle";
import { SectionSubtitle } from "src/modules/SectionSubtitle/SectionSubtitle";
import { IconCircle } from "src/modules/IconCircle/IconCircle";

export const Strengths = () => {
  return (
    <SectionContainer>
      <SectionTitle>テクノスタンダード AMSPの3つの強み</SectionTitle>
      <SectionSubtitle>
        従来のMSPサービスでは実現できなかった高品質かつコストパフォーマンスに優れたサービスを実現
      </SectionSubtitle>

      <Grid container spacing={4}>
        <Grid item xs={12} md={4}>
          <Box sx={strengthCardSx}>
            <IconCircle size="large" variant="primary">
              <Group sx={{ fontSize: "32px" }} />
            </IconCircle>
            <Typography variant="h3" sx={strengthTitleSx}>
              副業人材の活用
            </Typography>
            <Typography variant="body2" sx={strengthDescriptionSx}>
              通常の業務時間外でも柔軟な対応が可能です。
              <br />
              業務終了後・深夜帯・土日祝日も安心のサポート体制を構築しています。
              <br />
              IT企業で働くプロフェッショナルが副業として参画することで、質の高い対応を実現します。
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={12} md={4}>
          <Box sx={strengthCardSx}>
            <IconCircle size="large" variant="primary">
              <Bolt sx={{ fontSize: "32px" }} />
            </IconCircle>
            <Typography variant="h3" sx={strengthTitleSx}>
              ハイエンドエンジニア
            </Typography>
            <Typography variant="body2" sx={strengthDescriptionSx}>
              大手企業でマネージャー経験を持つエンジニアが対応します。
              <br />
              標準メニュー以外の複雑な問題にも対応可能で、豊富な実務経験と高度な技術力でお客様のシステムを支えます。
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={12} md={4}>
          <Box sx={strengthCardSx}>
            <IconCircle size="large" variant="primary">
              <SmartToy sx={{ fontSize: "32px" }} />
            </IconCircle>
            <Typography variant="h3" sx={strengthTitleSx}>
              生成AI活用
            </Typography>
            <Typography variant="body2" sx={strengthDescriptionSx}>
              最新の生成AI技術を導入し、一次対応の自動化・効率化を実現しています。
              <br />
              定型的な問い合わせに素早く対応し、人的リソースを複雑な問題解決に集中させることで、効率と品質を両立します。
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </SectionContainer>
  );
};

const strengthCardSx: SxProps<Theme> = (theme) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  gap: "20px",
  background: "#fff",
  padding: "40px 30px",
  borderRadius: "20px",
  boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
  border: "1px solid transparent",
  position: "relative",
  overflow: "hidden",
  "&::before": {
    content: '""',
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    height: "4px",
    background: "linear-gradient(90deg, #007bff, #28a745, #ffc107)",
  },
  [theme.breakpoints.down("sm")]: {
    padding: "30px 20px",
  },
});

const strengthTitleSx: SxProps<Theme> = {
  fontSize: "1.4rem",
  color: "#1a1a2e",
  fontWeight: 600,
};

const strengthDescriptionSx: SxProps<Theme> = {
  color: "#555",
  lineHeight: 1.7,
  fontSize: "1rem",
  textAlign: "left",
};
